import { render, staticRenderFns } from "./MasterCampaignStep1.vue?vue&type=template&id=22f212a4&"
import script from "./MasterCampaignStep1.vue?vue&type=script&lang=js&"
export * from "./MasterCampaignStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports